import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {FaBars} from 'react-icons/lib/fa';
import {Link} from 'react-router-dom';
import URLService from '../utils/URLService.js';
import AuthService from '../utils/AuthService.js';

import '../CSS/Template.css'
//import { mailFolderListItems, otherMailFolderListItems } from './tileData';

const styles = {
  list: {
    width: 250,
    color: 'white'
  },
  fullList: {
    width: 'auto',
    color: 'white'
  },
};

class LeftMenu extends React.Component {

  constructor(props){
    super(props)
    this.URLService = new URLService()
    this.AuthService = new AuthService()
    var url = this.URLService.getUrl()
    this.state = {
      top: false,
      left: false,
      bottom: false,
      right: false,
      url:url
    };
    this.clearAuthToken = this.clearAuthToken.bind(this)
    this.clearApptData = this.clearApptData.bind(this)
  }
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  clearAuthToken() {
    localStorage.removeItem('id_token')
    localStorage.removeItem('appointmentAddress')
    localStorage.removeItem('appointmentVehicles')
    localStorage.removeItem('appointmentVehicle')
    localStorage.removeItem('appointmentServices')
    localStorage.removeItem('allUpgradesArray')
    localStorage.removeItem('allUpgradesMap')
    localStorage.removeItem('appointmentUpgrades')
    localStorage.removeItem('promoAmount')
    localStorage.removeItem('apptDateTime')
    localStorage.removeItem('appointmentPackage')
    localStorage.removeItem('user')
    localStorage.removeItem('customer_id')
    window.location.href = "../login"
  }
  clearApptData() {
    localStorage.removeItem('appointmentAddress')
    localStorage.removeItem('appointmentVehicles')
    localStorage.removeItem('appointmentVehicle')
    localStorage.removeItem('appointmentServices')
    localStorage.removeItem('allUpgradesArray')
    localStorage.removeItem('allUpgradesMap')
    localStorage.removeItem('appointmentUpgrades')
    localStorage.removeItem('promoAmount')
    localStorage.removeItem('apptDateTime')
    localStorage.removeItem('appointmentPackage')
  }
  render() {
    const { classes } = this.props;

    const sideList = (
      <div className={classes.list}>
        <h1>TEST</h1>
      </div>
    );

    const fullList = (
      <div className={classes.fullList}>
        <h1>TEST</h1>
      </div>
    );
    var auth_token = localStorage.getItem('id_token')
    var token_string = ""
    var url = this.state.url
    return (
      <div>
        <Button className="hamButton"onClick={this.toggleDrawer('left', true)}><FaBars id="menuOpen" /></Button>
        <Drawer open={this.state.left} onClose={this.toggleDrawer('left', false)}>
          <div
            className="menu"
            tabIndex={0}
            role="button"
            onClick={this.toggleDrawer('left', false)}
            onKeyDown={this.toggleDrawer('left', false)}
          >
          <div>
            <a href="/dashboard">
              <ListItem button>
                  <ListItemText className="menuText" primary="Dashboard"/>
              </ListItem>
            </a>
            <a href="/new-appointment">
              <ListItem button onClick={this.clearApptData}>
                  <ListItemText className="menuText" primary="Schedule Service" />
              </ListItem>
            </a>
            {/*<a href="../subscriptions">*/}
            {/*  <ListItem button>*/}
            {/*      <ListItemText className="menuText" primary="Spiffy Care Subscriptions" />*/}
            {/*  </ListItem>*/}
            {/*</a>*/}
            <a href="../giftcards">
              <ListItem button>
                  <ListItemText className="menuText" primary="Giftcards" />
              </ListItem>
            </a>
            <a href='https://www.getspiffy.com/refer-a-friend-track-my-credit'  target="_blank" >
              <ListItem button>
                  <ListItemText className="menuText" primary="Refer A Friend" />
              </ListItem>
            </a>
            <a href= "../locations">
              <ListItem button>
                  <ListItemText className="menuText" primary="Update Locations" />
              </ListItem>
            </a>
            <a href="../vehicles">
              <ListItem button>
                  <ListItemText className="menuText" primary="Update Vehicles" />
              </ListItem>
            </a>
            <a href="../credit-cards">
              <ListItem button>
                  <ListItemText className="menuText" primary="Add/Delete Credit Card" />
              </ListItem>
            </a>
            <a href="../profile">
              <ListItem button>
                  <ListItemText className="menuText" primary="Profile" />
              </ListItem>
            </a>
            <a href={"https://www.getspiffy.com/appfaq"}>
              <ListItem button>
                  <ListItemText className="menuText" primary="FAQ's" />
              </ListItem>
            </a>
            <a href="../contact">
              <ListItem button>
                  <ListItemText className="menuText" primary="Contact Us" />
              </ListItem>
            </a>
            <ListItem button onClick={this.clearAuthToken}>
              <a>
                <ListItemText className="menuText" primary="Logout" />
              </a>
            </ListItem>
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}

LeftMenu.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeftMenu);



// WEBPACK FOOTER //
// ./src/Components/LeftMenu.js